import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="font-heading text-8xl md:text-9xl font-bold text-primary-500 mb-4">404</h1>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">页面未找到</h2>
        <p className="text-sm text-foreground-500 mb-8 max-w-sm mx-auto">
          您访问的页面不存在或已被移除。请检查链接是否正确，或者返回首页继续浏览韩漫。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-line w-4 h-4 flex items-center justify-center"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}